import React, { useEffect, useState } from "react";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { can } from "../../../utils/can";

export default function Country() {
const PAGE_SIZE = 10;

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const [success, setSuccess] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  // Religion list state
  const [country, setCountry] = useState([]);
  const [page, setPage] = useState(1);
  const [editId, setEditId] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [searchInput, setSearchInput] = useState("");
  const [activeSearch, setActiveSearch] = useState("");
  const token = localStorage.getItem("adminToken");


  const API_URL = process.env.REACT_APP_BASE_URL_API || ""; // make sure no trailing slash
  
const fetchcountry = async (pageNumber = 1, pSize = pageSize, currentSearch = activeSearch) => {
  setListLoading(true);
  
  try {
    let url = `${API_URL.replace(/\/$/, "")}/api/admin/country?page=${pageNumber}&limit=${pSize}`;
    if (currentSearch && currentSearch.trim()) {
      url += `&search=${encodeURIComponent(currentSearch.trim())}`;
    }
   
    const response = await fetch(url, {
          method: "GET",
          headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`, 
                    },
                  });
    const result = await response.json();

    if (response.ok) {
      setCountry(result.data);
      const computedTotal = result.totalPages
        ? result.totalPages
        : Math.ceil((result.totalCount || result.data.length || 0) / pSize) || 1;
      setTotalPages(computedTotal);
      } else {
        console.error(result.message || "Failed to fetch country.");
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    } finally {
      setListLoading(false);
    }
  };


  useEffect(() => {
    fetchcountry(page, pageSize, activeSearch);
  }, [page, pageSize, activeSearch]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    setActiveSearch(searchInput);
    fetchcountry(1, pageSize, searchInput);
  };

  const handleSearchReset = () => {
    setSearchInput("");
    setActiveSearch("");
    setPage(1);
    fetchcountry(1, pageSize, "");
  };

  // form submit
  const onSubmit = async (data) => {
    if(can("country","create") === false){
            alert("You don't have permission.");
            return;
        }

    setSuccess("");
    setErrorMsg("");
    setLoading(true);

    try {
      const url = editId
        ? `${API_URL.replace(/\/$/, "")}/api/admin/country/update/${editId}`
        : `${API_URL.replace(/\/$/, "")}/api/admin/country/create`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: data.name.trim(),
          status: data.isActive ? "Active" : "Deactive",
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess(editId ? "Country updated successfully!" : "Country added successfully!");
        setErrorMsg("");
        reset(); // clear form
        setEditId(null);
        fetchcountry(page, pageSize, activeSearch);
      } else {
        setErrorMsg(result.message || "Failed to save country.");
      }
    } catch (err) {
      console.error("Error:", err);
      setErrorMsg("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

   // Edit religion
  const handleEdit = (religion) => {
      if(can("country","edit") === false){
            alert("You don't have permission.");
            return;
        }

    setValue("name", religion.name);
    setValue("isActive", religion.status === "Active");
    setEditId(religion._id); // store id for update
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Delete religion
  const handleDelete = async (id) => {
      if(can("country","delete") === false){
            alert("You don't have permission.");
            return;
        }

    if (!window.confirm("Are you sure you want to delete this country?")) return;
    try {
      const response = await fetch(`${API_URL.replace(/\/$/, "")}/api/admin/country/delete/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      if (response.ok) {
        setSuccess("Country deleted successfully!");
        fetchcountry(page, pageSize);
      } else {
        setSuccess(result.message || "Failed to delete religion.");
      }
    } catch (err) {
      console.error(err);
      setSuccess("Something went wrong!");
    }
  };

  return (
    <div class="container body">
      <div class="main_container">
        <Sidebar />
        <Header pageTitle="Country" />
        {/* page */}
        <div className="right_col" role="main">
          {/* top tiles */}
         
          {/* /top tiles */}
          {/* body card start */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Country Entry</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>

              </ul>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              <div className="row">
                <div className="col-sm-12">
                  {/* filter start */}
                  <div className="filtercont">
                  <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="row">
                        <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                          <label>Enter Country</label>
                           <input
                            type="text"
                            className={`form-control ${errors.name ? "is-invalid" : ""}`}
                            {...register("name", { required: "Please enter country name" })}
                          />
                             {errors.religion && (
                                <div className="text-danger mt-1">{errors.religion.message}</div>
                              )}
                             
                        </div>
                        <div className="col-12" />
                        <div className="col-12 col-sm-4 pr-lg-0">
                          <input type="checkbox" id="active" {...register("isActive")} />
                          <label htmlFor="active" className="form-label">
                            Active/Deactive
                          </label>
                        </div>
                        <div className="col-12" />
                        <div className="col-12 col-sm-4 pr-lg-0 text-right">
                           <button type="submit" className="btn sitebtn" disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                           {success && <div className="text-success mt-1">{success}</div>}
                           {errorMsg && <div className="text-danger mt-1">{errorMsg}</div>}
                        </div>
                      </div>
                    </form>
                  </div>
                  {/* filter end */}
                </div>
              </div>
            </div>
          </div>
          {/* bod card end */}
          {/* Religion List Table */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Country List</h2>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              {/* Search Bar */}
              <div className="row mb-3">
                <div className="col-12 col-md-6 col-lg-4">
                  <form onSubmit={handleSearchSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search country..."
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                      />
                      <button className="btn sitebtn mb-0" type="submit" style={{ borderRadius: "0 4px 4px 0" }}>
                        <i className="fa fa-search" /> Search
                      </button>
                      {(activeSearch || searchInput) && (
                        <button
                          className="btn btn-secondary mb-0 ms-1 ml-1"
                          type="button"
                          onClick={handleSearchReset}
                        >
                          Reset
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>

              {listLoading ? (
                <div>Loading...</div>
              ) : (
                <div className="table-responsive">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <label className="mr-2">Show entries:</label>
                      <select
                        value={pageSize}
                        onChange={(e) => {
                          const newSize = parseInt(e.target.value, 10);
                          setPageSize(newSize);
                          setPage(1);
                        }}
                        className="form-control d-inline-block"
                        style={{ width: 120 }}
                      >
                        {[10, 25, 50, 100].map((s) => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div />
                  </div>

                  <table
                    className="table table-striped table-bordered bulk_action mytable"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: 20 }}>S.No</th>
                        <th>Country</th>
                        <th style={{ width: 120 }}>Status</th>
                        <th style={{ width: 120 }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {country.length > 0 ? (
                        country.map((item, index) => (
                          <tr key={item.id}>
                            <td>{(page - 1) * pageSize + index + 1}</td>
                            <td>{item.name}</td>
                            <td>
                              <div className="checkbox-wrapper-8">
                                <input
                                  className="tgl tgl-skewed"
                                  type="checkbox"
                                  checked={item.status === "Active"}
                                  readOnly
                                />
                                <label
                                  className="tgl-btn"
                                  data-tg-off="Inactive"
                                  data-tg-on="Active"
                                />
                              </div>
                            </td>
                            <td className="p-0">
                              <ul className="actionlist">
                                <li>
                                  <Link to={'#'} title="Edit" onClick={() => handleEdit(item)}>
                                    <i className="fa fa-edit" />
                                  </Link>
                                </li>
                                <li>
                                  <Link to={'#'}  title="Delete"  onClick={() => handleDelete(item._id)}>
                                    <i className="fa fa-trash" />
                                  </Link>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            No Country found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {/* Pagination */}
                  <div className="mt-3">
                    {Array.from({ length: totalPages }, (_, i) => (
                      <button
                        key={i}
                        className={`btn btn-sm mx-1 ${page === i + 1 ? "btn-primary" : "btn-light"}`}
                        onClick={() => setPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* bod card end */}

        </div>

        {/* page end */}
        <Footer />

      </div>
    </div>
  );
}